import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import { Form, Button, Dropdown, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactQuill from "react-quill";
import Select from "react-select";
import "react-quill/dist/quill.snow.css";
import { BASE_URL, security_key } from "../../../global";
import LinearProgress from "@mui/material/LinearProgress";
import JoditEditor from "jodit-react";
import EditorConfig from "./EditorConfig";
const AddRssArticleForm = () => {
    const [loading, setLoading] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const navigate = useNavigate();
    const formRef = useRef(null);
    const newTagRef = useRef(null);
    const editor = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [categoryOption, setCategoryOption] = useState([]);
    const [magazineOption, setMagazineOption] = useState([]);
    const [rssPostOption, setRssPostOption] = useState([]);
    const [statusOption, setStatusOption] = useState([
        { value: 1, label: "Draft" },
        { value: 2, label: "Published" },
        { value: 3, label: "Archived" },
    ]);
    const [url, setUrl] = useState([]);

    useEffect(() => {
        getAllCategory();
        getAllMagazine();
        // fetchAllRssLinks();
    }, []);

    const getAllCategory = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllCategory",
        });

        const output = response.data;

        if (output.length > 0) {
            setCategoryOption(
                output.map((option) => ({
                    value: option.pk_cat_key,
                    label: option.cat_name,
                }))
            );
        }
    };

    const getAllMagazine = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllMagForRssPost",
        });

        const output = response.data;

        if (output.length > 0) {
            setUrl(
                output.map((option) => ({
                    value: option.mag_link,
                    label: option.mag_name,
                    fk_mag_key: option.pk_mag_key,
                }))
            );
        }
    };

    // const fetchAllRssLinks = async () => {
    //     const response = await axios.post(BASE_URL + "API/apicall", {
    //         security_key: security_key,
    //         mode: "getAllRssfeedLinks",
    //     });

    //     const output = response.data;

    //     if (output.length > 0) {
    //         setUrl(
    //             output.map((option) => ({
    //                 value: option.rssfeed_link,
    //                 label: option.rssfeed_name,
    //             }))
    //         );
    //     }
    // };

    const [fullArticle, setFullArticle] = useState("");

    const getFullArticle = async (url) => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getFullArticle",
            url: url,
        });

        const output = response.data;

        if (output) {
            setFullArticle(output);
        }
    };

    function getImageDimensions(file) {
        return new Promise((resolve) => {
            const img = new Image();
            const reader = new FileReader();

            reader.onload = (e) => {
                img.onload = () => {
                    resolve({ width: img.width, height: img.height });
                };
                img.src = e.target.result;
            };

            reader.readAsDataURL(file);
        });
    }

    const initialValues = {
        // url: "https://rss.nytimes.com/services/xml/rss/nyt/MiddleEast.xml",
        ac_name: "",
        ac_summary: "",
        ac_img_link: null,
        ac_img_new: "",
        ac_content: "",
        created_by: sessionStorage.getItem("pk_user_key"),
        visibility: 1,
        tags: [],
        newTag: "",
        status: 1,
        fk_mag_key: null,
        category: [],
    };

    const validationSchema = Yup.object().shape({
        // url: Yup.string().url("Invalid URL format.").required("Rss-feed Link is required."),
        ac_name: Yup.string()
            .min(3, "Article Name must be at least 3 characters.")
            .max(100, "Article Name must be at most 100 characters.")
            .required("Article Name is required.")
            .test("unique-link", "Article Name is already existing in the database", async function (value) {
                if (!value) return true;
                const isArticleNameUnique = await checkArticleTitle(value);
                return isArticleNameUnique;
            }),

        ac_summary: Yup.string()
            // .matches(/^[^\s].*[^\s]$/, "Summary should not have leading or trailing spaces.")
            .min(90, "Article Summary must be at least 90 character.")
            // .max(300, "Article Summary must be at most 300 characters.")
            .required("Article Summary is required."),

        // ac_img_new: Yup.mixed().required("Article Image is required."),
        ac_img_new: Yup.mixed().test("imageRequired", "Article Image is required.", function (value) {
            const { ac_img_link } = this.parent;
            if (ac_img_link) {
                return true;
            } else {
                // return value != null && value !== "";
                return false;
            }
        }),

        // .test("fileType", "Unsupported File Format", (value) => {
        //     if (!value) return true;
        //     const supportedFormats = ["image/jpeg", "image/png", "image/gif"];
        //     return supportedFormats.includes(value.type);
        // })
        // .test("fileSize", "File size is too large", (value) => {
        //     if (!value) return true;
        //     const maxSize = 5 * 1024 * 1024; // 5MB limit
        //     return value.size <= maxSize;
        // })
        // .test("imageRatio", "Image ratio should be 16:9", async (value) => {
        //     if (!value) return true;
        //     const image = await getImageDimensions(value);
        //     const ratio = image.width / image.height;
        //     return Math.abs(ratio - 16 / 9) < 0.01;
        // }),

        ac_content: Yup.string().url("Invalid URL format.").required("Rss-feed content link is required."),

        tags: Yup.array().of(Yup.string()).default([]),
        newTag: Yup.string()
            .when("tags", (tags, schema) => {
                const flattenedTags = tags.flat().filter((tag) => tag !== "");
                if (flattenedTags.length === 0) {
                    return schema.required("Tag is required.");
                }
                return schema.notRequired();
            })
            .matches(/^[a-zA-Z0-9\s]*$/, "Tag can only contain letters and numbers."),

        status: Yup.string().required("Status is required."),
        // fk_mag_key: Yup.string().required("Magazine is required."),
        category: Yup.array()
            .of(Yup.string().required("Category is required."))
            .min(1, "At least one category must be selected.")
            .required("Category is required."),
    });

    async function checkArticleTitle(ac_name) {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "checkArticleTitle",
            ac_name: ac_name,
        });

        const output = response.data;

        return output == 1 ? false : true;
    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (formValues, selectedUrl) => {
            if (formValues.tags.length === 0) {
                formik.setFieldError("tags", "Please add at least one tag before submitting the article.");
                return;
            }

            toast.dismiss();
            setIsSubmitting(true);

            // Prepare the data to submit
            const dataToSubmit = {
                ...formValues,
                fk_mag_key: url.find((option) => option.value === values.url)?.fk_mag_key,
                ac_content: selectedRssItem?.link || formValues.ac_content,
                ac_img_new: values.ac_img_new, // Ensure the image is sent correctly
                ac_name: selectedRssItem?.title || formValues.ac_name,
                ac_summary: selectedRssItem?.description || formValues.ac_summary,
                // Add any other fields you want to pass
            };
            console.log("datatosubmit", dataToSubmit);
            if (!dataToSubmit.fk_mag_key) {
                toast.error("Magazine key is required.");
                return;
            }

            try {
                const response = await axios.post(
                    `${BASE_URL}API/apicall`,
                    {
                        security_key,
                        mode: "addRssFeed",
                        ...dataToSubmit,
                    },
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                const output = response.data;
                if (output == 1) {
                    formik.resetForm();
                    toast.success("Added successfully!", { autoClose: 3000 });

                    setTimeout(() => {
                        navigate("../rss-management");
                    }, 3000);
                } else {
                    toast.error("Oops! Something went wrong.", { autoClose: 3000 });
                }
            } catch (error) {
                toast.error("Error adding article: " + error.message);
            } finally {
                setIsSubmitting(false);
            }
        },
    });

    // Now, you can set variables as needed:
    const values = formik.values;
    const handleBlur = formik.handleBlur;
    const touched = formik.touched;
    const handleChange = formik.handleChange;
    const errors = formik.errors;
    const handleSubmit = formik.handleSubmit;
    const setFieldValue = formik.setFieldValue;
    const setTouched = formik.setTouched;
    const resetForm = formik.resetForm;
    const setValues = formik.setValues;
    const handleReset = formik.handleReset;

    const resetFormFields = (resetForm, setValues, initialValues) => {
        resetForm();
        setValues({
            ...initialValues,
        });
    };

    const handleAddTag = () => {
        if (values.newTag && !values.tags.flat().includes(values.newTag)) {
            setFieldValue("tags", [...values.tags.flat(), values.newTag]); // Flatten to avoid nested arrays
            setFieldValue("newTag", "");
            if (newTagRef.current) {
                newTagRef.current.focus();
                newTagRef.current.blur();
            }
        }
    };

    const handleRemoveTag = (tagToRemove) => {
        setFieldValue(
            "tags",
            values.tags.filter((tag) => tag !== tagToRemove)
        );
    };

    useEffect(() => {
        console.clear();
        // console.log(values);
        console.log(errors);
        // console.log(touched);
    }, [isSubmitting]);

    const [rssItems, setRssItems] = useState([]);
    const [selectedRssItem, setSelectedRssItem] = useState(null);

    const fetchRssFeed = async (selectedUrl) => {
        toast.dismiss();
        // Accept selectedUrl as a parameter
        if (!selectedUrl) {
            toast.warning("Please select a Article before fetching.");
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getRssFeedLinkData2",
                url: selectedUrl, // Use selectedUrl directly
            });

            console.log("Full Response:", response.data);

            const output = response.data;

            if (Array.isArray(output) && output.length > 0) {
                setRssPostOption(
                    output.map((option) => ({
                        value: option.title,
                        label: option.title,
                    }))
                );
                setRssItems(output);
                setSelectedRssItem(output[0]);
                setSelectedArticle(output[0]["title"]);
            } else if (output.error) {
                toast.error(output.error);
            } else {
                toast.error("Unexpected response structure.");
            }
        } catch (error) {
            toast.error("An error occurred while fetching the RSS feed.");
            console.error("Fetch error:", error);
        } finally {
            setLoading(false);
        }
    };

    const [selectArticle, setSelectedArticle] = useState("");

    // Function to populate form based on the selected RSS item
    const handleRssItemChange = (event) => {
        const selectedItemTitle = event.target.value;
        const selectedItem = rssItems.find((item) => item.title === selectedItemTitle);
        setSelectedRssItem(selectedItem);
        setSelectedArticle(selectedItemTitle);
    };

    // Update form values when selected RSS item changes
    useEffect(() => {
        if (selectedRssItem) {
            setFieldValue("ac_name", selectedRssItem.title || "");
            setFieldValue("ac_summary", selectedRssItem.description || "");
            // setFieldValue("ac_content", selectedRssItem.link || selectedRssItem.audio || "");
            setFieldValue("ac_content", selectedRssItem.link || "");
            setFieldValue("ac_img_link", selectedRssItem.image || "");
        }
    }, [selectedRssItem]);

    const handleFileChange = (e, index) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.addEventListener("load", () => {
                setFieldValue("ac_img_link", reader.result);
            });
            reader.readAsDataURL(file);
            setFieldValue("ac_img_new", file);
        }
    };

    const handlePreview = () => {
        if (values.ac_content && values.ac_content !== "") {
            getFullArticle(values.ac_content);
        }
        setShowPreview(true); // Show the preview modal
    };

    const handleClosePreview = () => {
        setShowPreview(false); // Hide the preview modal
    };

    return (
        <div className="container mt-4 bg-white p-4 mb-3">
            <ToastContainer position="top-center" />
            <Form className="mb-3" onSubmit={handleSubmit} ref={formRef}>
                <Form.Group className="d-flex justify-content-between mb-3 flex-sm-wrap">
                    <h4 className="mb-2">Add New Article</h4>
                    <div className="d-flex justify-content-between align-items-center sm-flex-wrap">
                        <Button variant="outline-dark" className="me-2 sm-mb-2" onClick={handlePreview}>
                            Preview
                        </Button>

                        <Button variant="dark" type="submit" disabled={isSubmitting}>
                            Add Article
                            {isSubmitting && <LinearProgress />}
                        </Button>
                    </div>
                </Form.Group>

                <div className="d-flex gap-2 mb-3 flex-sm-wrap flex-md-nowrap">
                    {/* <input
                            className="form-control me-2"
                            type="text"
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                            placeholder="Enter RSS feed URL"
                        /> */}
                    <Select
                        options={url}
                        id="url"
                        name="url"
                        className="w-50 w-sm-100 w-md-100 sm-mb-2 me-2"
                        onChange={(selectedOption) => {
                            console.log("Selected Option:", selectedOption);
                            const event = {
                                target: {
                                    name: "url",
                                    value: selectedOption.value,
                                },
                            };
                            handleChange(event);
                            // fetchRssFeed(selectedOption.value); // Call fetchRssFeed with the selected value
                        }}
                        onBlur={(event) => {
                            handleBlur(event);
                            setTouched({ ...touched, url: true });
                        }}
                    />

                    <Button type="button" variant="dark me-2" onClick={() => fetchRssFeed(values.url)}>
                        Fetch RSS Feed
                        {loading && <LinearProgress />}
                    </Button>

                    <Select
                        options={rssPostOption}
                        value={rssPostOption.filter((row) => row.value == selectArticle)}
                        className="w-50 w-sm-100 w-md-100 "
                        onChange={(selectedOption) => {
                            const event = {
                                target: {
                                    name: "title",
                                    value: selectedOption["value"],
                                },
                            };
                            handleRssItemChange(event);
                        }}
                    />
                </div>

                <Form.Group className="mb-3">
                    <Form.Label>
                        Title <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control type="text" name="ac_name" value={values.ac_name} onChange={handleChange} onBlur={handleBlur} placeholder="Title" />
                    {errors.ac_name && touched.ac_name && <p className="text-danger">{errors.ac_name}</p>}
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>
                        Summary <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        name="ac_summary"
                        value={values.ac_summary}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Summary"
                    />
                    {/* <JoditEditor
                        ref={editor}
                        config={EditorConfig}
                        value={values.ac_summary}
                        // onChange={(content) => {
                        //     const updatedFields = [...values.additionalFields];
                        //     updatedFields[index].value = content === "<p><br></p>" ? "" : content;
                        //     setFieldValue("additionalFields", updatedFields);
                        // }}
                        // onBlur={(content) => {
                        //     const updatedFields = [...values.additionalFields];
                        //     updatedFields[index].value = content === "<p><br></p>" ? "" : content;
                        //     setFieldValue("additionalFields", updatedFields);
                        // }}
                        placeholder="Summary"
                    /> */}
                    {errors.ac_summary && touched.ac_summary && <p className="text-danger">{errors.ac_summary}</p>}
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>
                        Content Link <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                        type="text"
                        name="ac_content"
                        value={values.ac_content}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Enter content link"
                    />
                    {errors.ac_content && touched.ac_content && <p className="text-danger">{errors.ac_content}</p>}
                </Form.Group>

                {/* {values.ac_img_link ? (
                        <img src={values.ac_img_link} class="rounded mx-auto d-block mb-3" alt="..."></img>
                    ) : (
                        <Form.Group controlId="articleImage" className="mb-3">
                            <div className="position-relative" style={{ cursor: "pointer" }}>
                                <img src={values.ac_img_link} class="rounded mx-auto d-block mb-3" alt="..."></img>
                                <Form.Label className="position-absolute" style={{ top: "0px", right: "0px" }}>
                                    <i class="bi bi-pencil-square"></i>
                                </Form.Label>
                            </div>

                            <Form.Control type="file" onChange={handleImageChange} onBlur={handleBlur} accept="image/*" style={{ display: "none" }} />
                            {errors.ac_img_new && touched.ac_img_new && <p className="text-danger">{errors.ac_img_new}</p>}

                        </Form.Group>
                    )} */}

                <Form.Group className="mb-3">
                    <Form.Label>
                        Image <span className="text-danger">*</span>
                    </Form.Label>
                    <label htmlFor="additionalImage" role="button" className="dropzone border p-4 rounded w-100 text-center">
                        <p>Drag 'n' drop an image here, or click to select one</p>
                        {values.ac_img_link && (
                            <img src={values.ac_img_link} alt="Additional" style={{ maxWidth: "100%", maxHeight: "200px", objectFit: "cover" }} />
                        )}
                    </label>
                    <input type="file" id="additionalImage" onChange={handleFileChange} onBlur={handleBlur} style={{ display: "none" }} accept="image/*" />
                    {errors.ac_img_new && touched.ac_img_new && <p className="text-danger">{errors.ac_img_new}</p>}
                </Form.Group>

                <div className="mb-3 d-flex gap-2 flex-sm-wrap flex-md-nowrap">
                    <Form.Group controlId="status" className="w-50 w-sm-100">
                        <Form.Label>
                            Status <span className="text-danger">*</span>
                        </Form.Label>
                        <Select
                            options={statusOption}
                            id="status"
                            name="status"
                            value={statusOption.find((option) => option.value && values.status && option.value.toString() === values.status.toString())}
                            onChange={(selectedOption) => {
                                const event = {
                                    target: {
                                        name: "status",
                                        value: selectedOption["value"],
                                    },
                                };
                                handleChange(event);
                            }}
                            onBlur={(event) => {
                                handleBlur(event);
                                setTouched({ ...touched, status: true });
                            }}
                        />

                        {errors.status && touched.status && <p className="text-danger">{errors.status}</p>}
                    </Form.Group>
                    <Form.Group controlId="category" className="w-50 w-sm-100">
                        <Form.Label>
                            Category <span className="text-danger">*</span>{" "}
                        </Form.Label>
                        <Select
                            options={categoryOption}
                            id="category"
                            name="category"
                            value={categoryOption.filter((option) => values.category.includes(option.value))}
                            isMulti
                            onChange={(selectedOptions) => {
                                const event = {
                                    target: {
                                        name: "category",
                                        value: selectedOptions.map((option) => option.value), // Map to an array of selected values
                                    },
                                };
                                handleChange(event);
                            }}
                            onBlur={(event) => {
                                handleBlur(event);
                                setTouched({ ...touched, category: true });
                            }}
                        />

                        {errors.category && touched.category && <p className="text-danger">{errors.category}</p>}
                    </Form.Group>
                    {/* <Form.Group controlId="fk_mag_key" className="w-50">
                            <Form.Label>
                                Magazine <span className="text-danger">*</span>{" "}
                            </Form.Label>
                            <Select
                                options={magazineOption}
                                id="fk_mag_key"
                                name="fk_mag_key"
                                value={magazineOption.filter((option) => values.fk_mag_key.includes(option.value))}
                                onChange={(selectedOption) => {
                                    const event = {
                                        target: {
                                            name: "fk_mag_key",
                                            value: selectedOption["value"],
                                        },
                                    };
                                    handleChange(event);
                                }}
                                onBlur={(event) => {
                                    handleBlur(event);
                                    setTouched({ ...touched, fk_mag_key: true });
                                }}
                            />

                            {errors.fk_mag_key && touched.fk_mag_key && <p className="text-danger">{errors.fk_mag_key}</p>}
                        </Form.Group> */}
                </div>
                <div className="mb-3 d-flex gap-2">
                    <Form.Group controlId="newTag" className="w-50">
                        <Form.Label>
                            Tag <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            ref={newTagRef}
                            value={values.newTag}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Add a tag"
                            className="form-control border"
                        />
                        {errors.newTag && touched.newTag && <p className="text-danger">{errors.newTag}</p>}
                        {errors.tags && touched.tags && <p className="text-danger">{errors.tags}</p>}
                    </Form.Group>

                    <div className="w-50">
                        <Button
                            variant="outline-dark"
                            onClick={handleAddTag}
                            id="addTagBtn"
                            className="p-0 p-1"
                            style={{ fontSize: "14px", marginTop: "30px" }}
                            disabled={!!errors.newTag && touched.newTag}
                        >
                            Add Tag
                        </Button>
                    </div>
                </div>
                {values.tags.length > 0 && (
                    <div className="mb-3">
                        <h6>Tags:</h6>
                        {values.tags.map((tag) => (
                            <span key={tag} className="badge bg-secondary me-4 position-relative" style={{ cursor: "pointer" }}>
                                {tag}
                                <span
                                    className="position-absolute translate-middle"
                                    style={{
                                        color: "red",
                                        top: "7px",
                                        right: "-25px",
                                        fontSize: "1rem",
                                        cursor: "pointer",
                                        padding: "0.2rem",
                                        zIndex: 1,
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleRemoveTag(tag);
                                    }}
                                >
                                    ×
                                </span>
                            </span>
                        ))}
                    </div>
                )}
            </Form>

            {/* Preview Modal */}
            <Modal show={showPreview} onHide={handleClosePreview} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Article Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: "800px", overflowY: "scroll" }}>
                    <h1 className="text-center">{values.ac_name}</h1>
                    <h5>{values.ac_summary}</h5>
                    {values.ac_img_link && <img src={values.ac_img_link} className="rounded mx-auto d-block mb-3" alt="..." />}

                    {values.ac_content && (
                        <div style={{ height: "600px" }}>
                            <iframe
                                src={
                                    values.ac_content.includes("youtube.com") || values.ac_content.includes("youtu.be")
                                        ? values.ac_content // Direct YouTube link
                                        : "https://thepaperboy.net/API/article_iframe.php?url=" + values.ac_content // Other content
                                }
                                title="Article Content"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    border: "none",
                                }}
                                allowFullScreen
                            />
                        </div>
                    )}

                    {/* <div>
                            <div
                                // style={{
                                //     position: "relative",
                                //     width: "100%", // or a specific width like '500px'
                                //     height: "500px", // or 'auto' or any specific height
                                //     overflowY: "auto", // enables vertical scrolling if content overflows
                                //     border: "1px solid #ccc", // optional: add a border for visibility
                                //     padding: "10px", // optional: add padding for better readability
                                //     boxSizing: "border-box", // includes padding and border in the element's total width and height
                                // }}
                                dangerouslySetInnerHTML={{ __html: fullArticle }}
                            />
                        </div> */}

                    {values.tags.length > 0 && (
                        <div className="mt-3">
                            <h6>Tags:</h6>
                            {values.tags.map((tag) => (
                                <span key={tag} className="badge bg-secondary me-2">
                                    {tag}
                                </span>
                            ))}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClosePreview}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default AddRssArticleForm;
